var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2864",
    "data-name": "Rectangle 2864",
    width: 26,
    height: 26,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(4 3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3415",
    "data-name": "Path 3415",
    d: "M21.73,14.505l-1.44-1.46a2.069,2.069,0,0,1-.54-1.324V8.846A6.492,6.492,0,0,0,13,2C8.68,2,6.25,5.058,6.25,8.846v3.195a1.2,1.2,0,0,1-.315.776L4.27,14.505a.919.919,0,0,0-.27.639V18.43a.906.906,0,0,0,.9.913H9.9a3.143,3.143,0,0,0,6.21,0h5a.906.906,0,0,0,.9-.913V15.144A.919.919,0,0,0,21.73,14.505Z",
    transform: "translate(-4 -2)",
    fill: "#A1A1B3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyBellIcon);
export default __webpack_public_path__ + "static/media/GreyBellIcon.f661b55f789738f547a8f5e74329bbf2.svg";
export { ForwardRef as ReactComponent };